<template>



  <section class="block intro bg-parent" :style="{ backgroundColor: $getField('intro_background_colour', data), color: $getField('intro_colour', data) }">

        <div class="bg-fade" v-lazy:background-image="'https://api.alt-design.net/api/image/' + $getField('intro_image', data)[0]"></div>

        <div class="intro-text" v-html="$getField('intro_text', data)">
        </div><!-- .intro-text -->

        <ul class="services">
            <li v-for="sector of $store.state.currentSectors">{{ getSector(sector) }}</li>
        </ul>

        <p class="link"><a target="_blank" :href="$getField('intro_link', data)">{{ $getField('intro_link_text', data) }}</a></p>

      <div class="block intro-mobile bg-parent" :style="{ backgroundColor: $getField('intro_background_colour', data), color: $getField('intro_colour', data) }">
          <div class="bg-fade" v-lazy:background-image="'https://api.alt-design.net/api/image/' + $getField('intro_image', data)[0]"></div>
      </div>

      </section>


</template>

<script>
export default {
  props: {
    data: [Array, Object]
  },
  created () {
    window.api.get('sectors').then(res => {
      this.$store.commit('updateCurrentSectors', res.data.data.data)
    })
  },
  methods: {
    getSector (id) {
      for (let sector of this.$store.state.availableSectors) {
        if (sector.id === id) {
          return sector.name
        }
      }
      return false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Projects/Rows/Intro.vue